import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postSubmitUploadEndpoint } from '../../../common/endpoints';

export const postSubmitUpload = createApi(postSubmitUploadEndpoint, 'POST');

const SubmitUpload = createSlice({
  name: 'SubmitUpload',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSubmitUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSubmitUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSubmitUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SubmitUpload.reducer;